<template>
  <div class="home-links links section">
    <div class="flex-row items-center">
      <div class="link-title">Links</div>
      <div class="link-line"></div>
    </div>
    <div class="flex-row flex-wrap justify-start freind-list">
      <a target="_blank" href="https://www.un.org/en/">United Nations (UN) </a>
      <a target="_blank" href="https://www.un.org/en/"
        >United Nations Educational, Scientific and Cultural Organization
        (UNESCO)
      </a>
      <a target="_blank" href="https://en.unesco.org/fieldoffice/beijing"
        >Representative of UNESCO Beijing Office
      </a>
      <a target="_blank" href="https://english.cas.cn/"
        >Chinese Academy of Sciences (CAS)
      </a>
      <a target="_blank" href="http://en.cae.cn/"
        >Chinese Academy of Engineering (CAE)
      </a>

      <a target="_blank" href="http://english.cast.org.cn/"
        >China Association for Science and Technology (CAST)
      </a>
      <a target="_blank" href="https://www.ieagreements.org/"
        >International Engineering Alliance (IEA)
      </a>

      <a target="_blank" href="https://www.tsinghua.edu.cn/en/"
        >Tsinghua University
      </a>

      <a target="_blank" href="https://www.wfeo.org/"
        >World Federation of Engineering Organizations (WFEO)
      </a>

      <a target="_blank" href="https://www.sefi.be/"
        >European Society for Engineering Education (SEFI）
      </a>
      <a target="_blank" href="http://www.gedcouncil.org/"
        >Global Engineering Deans Council (GEDC)
      </a>
      <a target="_blank" href="https://www.fidic.org/"
        >International Federation of Consulting Engineers (FIDIC)
      </a>
      <a target="_blank" href="https://www.asee.org/"
        >American Society for Engineering Education (ASEE)
      </a>
      <a target="_blank" href="https://www.abet.org/"
        >Accreditation Board for Engineering and Technology (ABET)
      </a>
      <a target="_blank" href="http://en.most.gov.cn/"
        >Ministry of Science and Technology of the People´s Republic of China
      </a>
      <a target="_blank" href="https://www.newcaets.org/"
        >International Council of Academies of Engineering and Technological
        Sciences（CAETS）
      </a>
      <a target="_blank" href="https://www.ifees.net/"
        >International Federation of Engineering Education Societies (IFEES)
      </a>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  components: {},
  name: "HomeLinks",
  props: {
    data: {
      type: Object,
      defalut: () => {
        return {};
      },
    },
  },
  setup() {
    return {};
  },
});
</script>

<style lang="scss" scoped>
.links {
  .link-title {
    width: 70px;
    height: 28px;
    font-size: 20px;
    font-weight: 600;
    color: #1c7fbb;
    line-height: 28px;
    margin: 24px 0 20px;
  }
  .link-line {
    width: 1206px;
    height: 1px;
    background-color: #2282bc;
  }
  a {
    height: 20px;
    font-size: 14px;
    font-weight: 400;
    color: #373737;
    line-height: 20px;
    margin-bottom: 20px;
    margin-right: 40px;
    &:hover {
      color: #0364ff;
    }
  }
}
</style>
